import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { useCheckable } from '../hooks/use-checkable.js';
import { useSharedRef } from '../hooks/use-shared-ref.js';

/**
 * CheckboxPrimitive is an unstyled (“headless”) component that handles button functionality and a11y concerns.
 * Use CheckboxPrimitive for binary choices that don't match any UI3 styling.
 *
 * @see https://fpl.figma.design/primitives/checkbox/
 */
const CheckboxPrimitive = forwardRef((props, refIn) => {
    const ref = useSharedRef(refIn);
    const checkableProps = useCheckable({ ...props, inputRef: ref });
    return (jsx("input", { "data-fpl-component": "primitive", ...checkableProps, type: "checkbox", ref: ref, "aria-disabled": props['aria-disabled'] || props.disabled || undefined }));
});
CheckboxPrimitive.displayName = 'CheckboxPrimitive';

export { CheckboxPrimitive };
//# sourceMappingURL=checkbox-primitive.js.map
